var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 6.40675C23.9017 8.33866 25.625 11.4681 25.625 15C25.625 20.868 20.868 25.625 15 25.625H14.375M8.75 23.5933C6.09833 21.6613 4.375 18.5319 4.375 15C4.375 9.13197 9.13198 4.375 15 4.375H15.625M16.25 28L13.75 25.5L16.25 23M13.75 7L16.25 4.5L13.75 2",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3205 11.7705C12.3205 11.2621 12.3205 11.0079 12.4267 10.8659C12.5192 10.7423 12.6609 10.6649 12.8149 10.6539C12.9916 10.6412 13.2053 10.7787 13.6327 11.0536L18.6582 14.2862C19.029 14.5248 19.2145 14.6441 19.2785 14.7958C19.3345 14.9283 19.3345 15.0778 19.2785 15.2104C19.2145 15.3621 19.029 15.4813 18.6582 15.7199L13.6327 18.9525C13.2053 19.2274 12.9916 19.3649 12.8149 19.3523C12.6609 19.3413 12.5192 19.2639 12.4267 19.1402C12.3205 18.9983 12.3205 18.7441 12.3205 18.2357V11.7705Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.f790e7826a3312f95386eb6b5e8d9b6a.svg";
export { ForwardRef as ReactComponent };